// obsolated, not support mulit time range
export default function timerange(value) {
  let returnValue = "";

  let off = false;

  if (value.off) {
    off = value.off;
  }
  if (off) returnValue = "closed";
  else if (value.timeFrom && value.timeTo) {
    let timeFrom = "";
    let timeTo = "";

    timeFrom = tConvert(value.timeFrom);
    timeTo = tConvert(value.timeTo);

    returnValue = timeFrom + "-" + timeTo;
  }

  return returnValue;
}

function tConvert(time) {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join(""); // return adjusted time or original string
}
